// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Mypage_contentWrapper__4Z0bM"};